import styles from './addskubanner.module.scss';

/* types */
type AddSkuPageBannerProps = {
  banner: string | null;
};

export default function AddSkuPageBanner({ banner = null }: AddSkuPageBannerProps) {
  const containerStyles = styles.bannerWrapper;
  return banner ? (
    <div className={containerStyles}>
      <p className={styles.skuBanner}>
        <strong>Note: </strong>
        {banner}
      </p>
    </div>
  ) : null;
}
